export var valuesPlattformRights = ["AssetManagement"];
/*

*/ 
//# sourceMappingURL=PlattformRights.js.map